import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const SiteSettingsContext = createContext();
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Default fallback settings to prevent 500 errors from breaking the app
const DEFAULT_SITE_SETTINGS = {
  site_name: 'United Pharma Technologies',
  meta_description: 'United Pharma Technologies - Life Sciences Validation, Staffing & Consulting',
  meta_keywords: 'United Pharma Technologies, pharma services, validation, consulting',
  favicon: '/favicon.ico'
};

export const SiteSettingsProvider = ({ children }) => {
  const [siteSettings, setSiteSettings] = useState(DEFAULT_SITE_SETTINGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

    axios.get(`${API}/site_settings`, {
      signal: controller.signal,
      timeout: 5000
    })
      .then(res => {
        if (res.data && res.data.err_code === 'valid' && res.data.data) {
          // Merge with defaults to ensure all required fields exist
          setSiteSettings({ ...DEFAULT_SITE_SETTINGS, ...res.data.data });
        } else {
          setSiteSettings(DEFAULT_SITE_SETTINGS);
        }
      })
      .catch(err => {
        console.warn('Failed to fetch site settings, using defaults:', err.message);
        // Use default settings on any error to prevent the app from breaking
        setSiteSettings(DEFAULT_SITE_SETTINGS);
      })
      .finally(() => {
        clearTimeout(timeoutId);
        setLoading(false);
      });

    return () => {
      controller.abort();
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ siteSettings, loading }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext); 